import { useB2bContext } from '@/features/b2b/b2b-context'
import { CommonMapSearch } from '@/features/common/common-map-search'

export const B2bMapSearch = () => {
    const { onSelect } = useB2bContext()

    return <CommonMapSearch tBaseKey="for-companies" onSelect={onSelect} />
}
